export const COMMON_QUERY_KEYS = {
  game: (id: string) => ['GAME', id],
  gameShort: (id: string) => ['GAME_SHORT', id],
  roundGames: (tournamentId: string, roundId: string) => ['ROUND_GAMES', tournamentId, roundId],
  roundShortGames: (tournamentId: string, roundNumber: number) => [
    'ROUND_SHORT_GAMES',
    tournamentId,
    roundNumber,
  ],
};
